if (!customElements.get('mv-swatch-picker')) {
  // Drives the hidden native <variant-selects> (Dawn keeps handling price,
  // media, URL and the cart variant) and mirrors its state back. Dawn replaces
  // that element on every variant change, so it is looked up each time.
  class MvSwatchPicker extends HTMLElement {
    connectedCallback() {
      if (!this.native) return;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value-id]');
        if (!button || !this.contains(button)) return;
        this.select(button);
      });

      this.observer = new MutationObserver(() => this.syncFromNative());
      this.observer.observe(this.parentElement, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    get native() {
      const previous = this.previousElementSibling;
      if (previous?.matches('variant-selects')) return previous;
      return this.parentElement?.querySelector('variant-selects') || null;
    }

    nativeInput(id) {
      return this.native?.querySelector(`input[data-option-value-id="${id}"]`) || null;
    }

    select(button) {
      const input = this.nativeInput(button.dataset.optionValueId);
      if (!input || input.checked) return;
      this.markSelected(button);
      input.click();
    }

    markSelected(button) {
      const group = button.closest('.mv-swatches');
      group.querySelectorAll('[data-option-value-id]').forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      const label = group.querySelector('[data-mv-selected-value]');
      if (label && label.textContent !== button.dataset.value) label.textContent = button.dataset.value;
    }

    syncFromNative() {
      this.querySelectorAll('[data-option-value-id]').forEach((button) => {
        const input = this.nativeInput(button.dataset.optionValueId);
        if (!input) return;
        const unavailable = input.classList.contains('disabled');
        if (button.classList.contains('is-unavailable') !== unavailable) {
          button.classList.toggle('is-unavailable', unavailable);
        }
        if (input.checked && !button.classList.contains('is-selected')) this.markSelected(button);
      });
    }
  }

  customElements.define('mv-swatch-picker', MvSwatchPicker);
}
